<template>
    <div class="row" style="position: relative;">
        <WriteSummaryTextarea v-model="showDialog" :planData='planData' :temp_summary='temp_summary' type='download'
                              @cancel="clickCancel()"
                              @close="clickClose()" @confirm="clickConfirm()"
                              @updateSummary="updateSummary"></WriteSummaryTextarea>

        <ConfirmDialog :buttons="buttons" :content="''" :show="show_confirm_dialog"
                       :title="'确认删除本条数据?'"
                       @cancel="close_confirm_dialog" @close_dialog="close_confirm_dialog"
                       @confirm="delete_plan($event)"></ConfirmDialog>
        <div class="col-md-12 pr-0 tpl-portlet-components" style="padding: 0;margin-bottom: 0 !important;">
            <div class="tpl-portlet-title" style="border-bottom: 1px solid rgb(215, 216, 217)">
                <div class="left">
                    <router-link v-if="isOwner" :to="{ name: ref_page}"
                                 style="padding: 7px;position: absolute; left: 2%;top: 2px;font-size: 14px;">
                        <i class="el-icon-arrow-left">返回</i>
                    </router-link>
                    <router-link v-else :to="{ name: ref_page, query:{uid:currUid}}"
                                 style="padding: 7px;position: absolute; left: 2%;top: 2px;font-size: 14px;">
                        <i class="el-icon-arrow-left">返回</i>
                    </router-link>
                    <a v-if="isOwner" id="delete-button" class="width73 margin-right-a10"
                       style="position: relative;top: 10px;left: 75%;"
                       @click="to_delete_plan(plan_info.id)">删除</a>
                    <router-link v-if="isOwner"
                                 :to="{ name: 'editmobileplan',params: { id: plan_info.id}}"
                                 tag="a">
                        <el-button size="mini" style="padding: 7px;position: absolute; right: 3%;top: 6px;"
                                   type="primary">编辑
                        </el-button>
                    </router-link>
                </div>
            </div>
            <div class="new-main" style="margin-bottom: 20px">
                <div class="edit-plan-detail">
                    <div class="plan-head">
                        <i class="fa fa-calendar" style="font-size: 24px;margin-top: 0px;"></i>
                        <div style="width: 95%;">
                            <p class="font-16" style="margin-bottom: 5px;">
                                {{ plan_info.title }}
                            </p>
                            <div class="text-l-gray" style="font-size: 12px;margin: 0;">
                                <span v-if="!isOwner">{{ plan_info.creatorName }}</span>
                                <span v-if="plan_info.plan_type=='week'" class="name-info font12"> 周计划</span>
                                <span v-if="plan_info.plan_type=='month'" class="name-info font12">月计划</span>
                                <span v-if="plan_info.plan_type=='quarter'" class="name-info font12"> 季度计划</span>
                                <span v-if="plan_info.plan_type=='custom'" class="name-info font12"> 自定义计划</span>
                                <div class="progress" style="margin: 0 10px;width: 86px;" title="计划进度">
                                    <span class="orange"
                                          v-bind:style="{width:Math.floor(plan_info.rate_of_progress * 100) / 100+'%'}"><span>{{ Math.floor(plan_info.rate_of_progress * 100) / 100 }}%</span></span>
                                </div>
                            </div>
                            <p class="text-l-gray" style="font-size: 12px;margin: 0;">
                                          <span class="font12" style="">
                                    周期：{{ plan_info.open_time }} -  {{ plan_info.end_time }}
                                </span>
                                <span class="font12">
                                    发布：{{ plan_info.publish_time }}
                                </span>

                            </p>
                        </div>
                    </div>
                    <div class="plan-body" style="min-height: 400px;">
                        <table>
                            <tbody>
                            <tr>
                                <td>
                                    <!-- 内容 -->
                                    <table class="text-m-gray table-content">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <div class="vertical-top">
                                                    <div class="text-h-gray bold  plan-title">

                                                        <b>{{ plan_info.content }}</b></div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <ul v-if="details_info.length > 0"
                                                    class="text-m-gray color333 plan-content">
                                                    <li v-for="(detail,index) in details_info"
                                                        v-if="!detail.isDelete"
                                                        :key="index" class="detail-item clearfix ">
                                                        <div id="detailEditTip" class="detail-item-content-wrap">
                                                            <div class="circle-progress"
                                                                 style="float: left;cursor: pointer;">
                                                                <div class="num" title="点击更新细则进度">
                                                                    <div class="circle_Percent"
                                                                         style="position: relative"
                                                                         @click="updateProgress(detail)">
                                                                        <div class="circleProgress">
                                                                            <div :class="classObject(detail.rate_of_progress)">
                                                                                <div class="circleLeft"></div>
                                                                                <div class="circleRight"></div>
                                                                                <!--                                                                                <div class="progressNum">-->
                                                                                <!--                                                                                    <span style="font-size: 7px;">   {{-->
                                                                                <!--                                                                                            detail.rate_of_progress-->
                                                                                <!--                                                                                        }}</span>-->

                                                                                <!--                                                                                </div>-->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="break-all detail-item-content">
                                                                <div style="float: left;width: 95%;">
                                                                    {{ detail.details }}
                                                                </div>

                                                                <div style="float: left;width:99%;font-size: 12px;margin-top: 5px;">
                                                                        <span class="font12 text-l-gray"
                                                                              style="float: left;width: 35%;">
                                                                            {{
                                                                                new Date(detail.start_time).getMonth() + 1 + '-' + new Date(detail.start_time).getDate()
                                                                            }}
                                                                             ~
                                                                            {{
                                                                                new Date(detail.end_time).getMonth() + 1 + '-' + new Date(detail.end_time).getDate()
                                                                            }}
                                                                        </span>
                                                                    <div style="font-size: 12px;overflow: hidden;float: left;margin-left: 5%;width: 40%;">
                                                                        <div v-if="detail.isImportant"
                                                                             style="float: left;width: 55%;">
                                                                            <span class="name-info font12 text-l-gray"
                                                                                  style="margin-left: 5px;">重要</span>
                                                                            <i class="font12 fa fa-check"
                                                                               style="margin-left: 5px;color: darkgreen;font-weight: bold"></i>
                                                                        </div>
                                                                        <div v-if="detail.isEmergency"
                                                                             style="float: left;width: 50%;">
                                                                            <span class="name-info font12 text-l-gray"
                                                                                  style="margin-left: 5px;">紧急</span>
                                                                            <i class="font12 fa fa-check"
                                                                               style="margin-left: 5px;color: red;font-weight: bold"></i>
                                                                        </div>

                                                                        <!-- <span v-html="err">   </span>-->
                                                                    </div>
                                                                    <i v-if="detail.plan_id === plan_info.id && isOwner"
                                                                       class="el-icon-delete-solid icon-remove"
                                                                       title="删除该计划细则"
                                                                       v-on:click='del_detail(index, detail.id)'></i>
                                                                    <el-popover
                                                                            v-if="detail.plan_id !== plan_info.id && isOwner"
                                                                            content="该细则不属于本计划"
                                                                            placement="top"
                                                                            trigger="click"
                                                                            width="100">
                                                                        <i slot="reference"
                                                                           class="el-icon-info icon-remove"
                                                                        ></i>
                                                                    </el-popover>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <p v-if="other_details_info.length > 0"
                                                   style="margin: 0;height: 32px;line-height: 32px;">其他细则
                                                    {{ other_details_info.length }}</p>
                                                <ul v-if="other_details_info.length > 0"
                                                    class="text-m-gray color333 plan-content">
                                                    <li v-for="(detail,index) in other_details_info"
                                                        v-if="!detail.isDelete"
                                                        :key="index" class="detail-item clearfix ">
                                                        <div id="detailEditTip" class="detail-item-content-wrap">
                                                            <div class="circle-progress"
                                                                 style="float: left;cursor: pointer;">
                                                                <div class="num" title="点击更新细则进度">
                                                                    <div class="circle_Percent"
                                                                         style="position: relative"
                                                                         @click="updateProgress(detail)">
                                                                        <div class="circleProgress">
                                                                            <div :class="classObject(detail.rate_of_progress)">
                                                                                <div class="circleLeft"></div>
                                                                                <div class="circleRight"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="break-all detail-item-content">
                                                                <div style="float: left;width: 85%;">
                                                                    {{ detail.details }}
                                                                </div>

                                                                <div style="float: left;width:99%;font-size: 12px;margin-top: 5px;">
                                                                        <span class="font12 text-l-gray"
                                                                              style="float: left;width: 30%;">{{
                                                                                detail.start_time.substring(6)
                                                                            }} ~ {{ detail.end_time.substring(6) }}
                                                                        </span>
                                                                    <div style="font-size: 12px;overflow: hidden;float: left;margin-left: 5%;width: 40%;">
                                                                        <div v-if="detail.isImportant"
                                                                             style="float: left;width: 50%;">
                                                                            <span class="name-info font12 text-l-gray"
                                                                                  style="margin-left: 5px;">重要</span>
                                                                            <i class="font12 fa fa-check"
                                                                               style="margin-left: 5px;color: darkgreen;font-weight: bold"></i>
                                                                        </div>
                                                                        <div v-if="detail.isEmergency"
                                                                             style="float: left;width: 50%;">
                                                                            <span class="name-info font12 text-l-gray"
                                                                                  style="margin-left: 5px;">紧急</span>
                                                                            <i class="font12 fa fa-check"
                                                                               style="margin-left: 5px;color: red;font-weight: bold"></i>
                                                                        </div>

                                                                        <!-- <span v-html="err">   </span>-->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <!-- 总结 -->
                                    <table class="text-m-gray conclusion break-all">
                                        <tbody>
                                        <tr>
                                            <td class="bold  v-top"
                                                style="padding-top: 10px;padding-bottom: 10px;width: 40px;">
                                                总结：
                                            </td>
                                            <td class=""
                                                style="position: relative;padding-top: 10px;padding-bottom: 10px;">
                                                <div class="vertical-top color333" v-html="plan_info.summary"></div>

                                            </td>
                                            <td v-if="isOwner" style="width: 80px;text-align: center">
                                                <button class="publish_button" @click="openWriteDialog(plan_info)"><i
                                                        class="fa fa-pencil"
                                                        style="font-size: 10px;
                                                            margin-right: 5px;"></i>总结
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </td>
                            </tr>

                            <tr>
                                <td class="v-top"><i class="icon-comment mar-tr-4"></i></td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import ConfirmDialog from '@/components/common_components/dialog/confirm_dialog.vue'
    import WriteSummaryTextarea from '@/apps/plan/sub_components/dialog/write_summary_textarea.vue'
    import planApi from '@/api/plan/plan_api.js'
    import {mapActions, mapGetters, mapState} from 'vuex'

    export default {
        name: "view_plan",
        data: function () {
            return {
                err: '&#12288;',
                showDialog: false,
                planData: null,
                show_confirm_dialog: false,
                plan_type: '',
                details_info: [],
                other_details_info: [],
                buttons: [],
                isOwner: true,
                currUid: 0,
            startDate: '',
            temp_summary: '',
            my_plans: [],
            next_plan: null,
            }
        },
        components: {
            ConfirmDialog,
            WriteSummaryTextarea,
        },
        computed: {
            ...mapState({
                plan_info: state => state.plan.plan_information,
                active_plan_id: state => state.plan.active_plan_id,
                ref_page: state => state.plan.ref_page,
                login_user_id: state => state.loginState.user_info.id,
            }),
            ...mapGetters({}),
        },
        methods: {
            ...mapActions({
                get_plan_info: 'plan/get_plan_info',
                delete: 'plan/delete_plan',
                change_active_plan_id: 'plan/change_active_plan_id',
                change_ref_page: 'plan/change_ref_page',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            classObject: function (rate) {
                if (rate == 25) return 'circle25'
                if (rate == 50) return 'circle50'
                if (rate == 75) return 'circle75'
                if (rate == 100) return 'circle100'
            },
        openWriteDialog: function (plan) {
            this.update_next_plan_date();
            for (let i = 0; i < this.my_plans.length; i++) {
                if (this.plan_type === 'month') {
                    if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() === this.startDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) === (this.startDate.getMonth() + 1)) {
                        this.next_plan = this.my_plans[i];
                        break
                    }
                }
                if (this.plan_type === 'week') {
                    if (this.my_plans[i].plan_type === "week" && (new Date(this.my_plans[i].open_time)).getFullYear() === this.startDate.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() === this.startDate.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() === this.startDate.getDate()) {
                        this.next_plan = this.my_plans[i];
                        break
                    }
                }
                if (this.plan_type === 'quarter') {
                    if (this.my_plans[i].plan_type === "quarter" && (new Date(this.my_plans[i].open_time)).getFullYear() === this.startDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) === (this.startDate.getMonth() + 1)) {
                        this.next_plan = this.my_plans[i];
                        break
                    }
                }
            }
            let next_detail = ''
            if (this.next_plan == null) {
                next_detail = '暂无制定计划';
            } else {
                next_detail = this.next_plan.title;
                let index = 1;
                for (const detail of this.next_plan.details_info) {
                    next_detail += '\n细则' + index + '：' + detail.details;
                    index++;
                }
            }
            this.temp_summary = '一、当前计划\n1、完成度：' + Math.floor(this.plan_info.rate_of_progress * 100) / 100
                + '%\n2、本周心得：\n\n二、下次计划\n' + next_detail + '\n\n三、总结：\n'
                this.showDialog = true;
                this.planData = plan;
            },
            to_delete_plan(plan_id) {
                this.buttons = [{
                    'name': '取消',
                    'method': 'cancel',
                    'params': {},
                    'style': 'button-primary button-default'
                }, {'name': '确定', 'method': 'confirm', 'params': {'plan_id': plan_id}, 'style': 'button-primary'}]
                this.open_confirm_dialog();
            },
            open_confirm_dialog: async function () {
                this.show_confirm_dialog = true;
            },
            close_confirm_dialog() {
                this.show_confirm_dialog = false;
            },
            delete_plan(params) {
                this.delete(params).then((response) => {
                    let data = response.data;
                    this.change_warning_message(data.message);
                    if (data.code === 'success') {
                        this.change_warning_bar_style_class('success');
                        this.close_confirm_dialog();
                        this.$router.push({name: 'mobileplan'});
                    } else {
                        this.change_warning_bar_style_class('alert');
                    }
                })
            },
            clickCancel() {
            },
            clickConfirm() {
            },
            clickClose() {
                this.showDialog = false;
            },
            del_detail: async function (index, detail_id) {
                const post_param = {
                    detail_id: detail_id
                };
                const response = await planApi.delete_plan_detail_to_recycle(post_param);
                const data = JSON.parse(response.data.result);
                if (data.code === 'success') {
                    this.details_info.filter(x => x.id === detail_id)[0].isDelete = true;
                    this.plan_info.details_info.filter(x => x.id === detail_id)[0].isDelete = true;
                } else {
                    this.change_warning_bar_style_class('alert');
                }
            },
            updateSummary(summary) {
                this.plan_info.summary = summary
            },
            updateProgress: async function (detail) {
                if (this.isOwner === false) return;
                let newProgress = detail.rate_of_progress + 25
                if (newProgress > 100) newProgress = 0
                let vals = {
                    detail_id: detail.id,
                    progress: newProgress,
                }
                let res = await planApi.modify_plan_detail_progress(vals)
                let data = JSON.parse(res.data.result);
                this.change_warning_message(data.message);
                if (data.code === 'success') {
                    this.change_warning_bar_style_class('success');
                    detail.rate_of_progress = newProgress
                } else {
                    this.change_warning_bar_style_class('alert');
                }
        },
        update_next_plan_date: function () {
            if (this.plan_type === 'week') {
                this.startDate = new Date(this.getBeforeDate(this.startDate, -7))
            }
            if (this.plan_type === 'quarter') {
                let tempM = this.startDate.getMonth() + 1;
                let tempY = this.startDate.getFullYear();
                tempM = tempM < 10 ? ('0' + tempM) : ('' + tempM);
                let tempIdx = this.quarterArray.indexOf(tempM);
                if (tempIdx === 3) {
                    tempY = tempY + 1;
                    tempM = this.quarterArray[0];
                } else tempM = this.quarterArray[tempIdx + 1];
                this.startDate = new Date(tempY + '-' + tempM + '-01');
            }
            if (this.plan_type === 'month') {
                let tempM = this.startDate.getMonth() + 2;
                let tempY = this.startDate.getFullYear();
                if (tempM === 13) {
                    tempM = 1;
                    tempY = tempY + 1;
                }
                tempM = tempM < 10 ? ('0' + tempM) : tempM;
                this.startDate = new Date(tempY + '-' + tempM + '-01');
            }
        },
        getBeforeDate: function (theDate, number) {
            const num = number;
            const date = new Date(theDate);
            let year = date.getFullYear();
            let mon = date.getMonth() + 1;
            let day = date.getDate();
            if (day <= num) {
                if (mon > 1) {
                    mon = mon - 1;
                } else {
                    year = year - 1;
                    mon = 12;
                }
            }
            date.setDate(date.getDate() - num);
            year = date.getFullYear();
            mon = date.getMonth() + 1;
            day = date.getDate();
            const s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day);
            console.log(s);
            return s;
        },
        },
        watch: {
            plan_info: async function (value, oldValue) {
                let args = {
                    'planid': this.plan_info.id,
                    'uid': this.plan_info.creator,
                    'sdate': value.open_time,
                    'edate': value.end_time,
                    'ptype': value.plan_type,
                }

                let d = await planApi.get_my_todos_by_date(args);
                let curr_details = d.data.filter(x => x.plan_id === this.plan_info.id);
                let other_details = d.data.filter(x => x.plan_id !== this.plan_info.id);
                this.details_info = [].concat(curr_details.sort((a, b) => a.id - b.id));
                this.other_details_info = []
                    .concat(other_details.sort(function (a, b) {
                        if (a.plan_id === b.plan_id) return a.id - b.id;
                        else return a.plan_id - b.plan_id;
                    }));

            this.plan_type = this.plan_info.plan_type;
            this.startDate = new Date(this.plan_info.open_time);
            if (this.plan_info.creator !== this.login_user_id) {
                this.isOwner = false;
            }
            }
        },
        created() {
            let uid = this.$route.params.uid;
            if (uid) {
                if (uid !== this.login_user_id) {
                    this.isOwner = false;
                    this.currUid = uid;
                }
            }
            console.log('this.isOwner' + this.isOwner)
        },
    mounted: async function () {
            let pId = this.$route.params.id;
            let qId = this.$route.query.id;
            let rPage = this.$route.params.ref_page;
            let uid = this.$route.params.uid;
            if (typeof (rPage) != "undefined") {
                this.change_ref_page(this.$route.params.ref_page);
            }
            if (uid) {
                if (uid !== this.login_user_id) {
                    this.isOwner = false;
                    this.currUid = uid;
                }
            }
            if (typeof (pId) != "undefined") {
                this.get_plan_info(pId);
                this.change_active_plan_id(pId);
            } else if (typeof (qId) != "undefined") {
                this.get_plan_info(qId);
                this.change_active_plan_id(qId);
            } else this.get_plan_info(this.active_plan_id);

        this.my_plans = (await planApi.get_my_plans()).data;
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/progress.css';

    .top-bar {
        position: relative;
        padding: 10px 20px;
        overflow: hidden;
        background-color: #fff;
    }

    .top-bar .left {
        font-weight: normal;
        float: left;
    }

    /*.top-bar button {*/
    /*    height: 28px;*/
    /*    background-color: #fff;*/
    /*    border: 1px solid #d7d8d9;*/
    /*}*/

    .margin-right-a10 {
        margin-right: 10px;
    }

    .width73 {
        width: 73px !important;
    }

    button, a.btn {
        border-radius: 2px;
        border-style: none;
    }

    .icon-remove {
        position: relative;
        top: 1px;
        float: right;
        right: 10%;
        font-size: 14px;
    }

    .detail-item .remove {
        font-size: 18px;
        position: relative;
        text-shadow: none;
        top: 1px;
        margin-top: 4px;
        margin-left: 1px;
        margin-right: 16px;
        color: #a7bdcd;
        font-style: normal;
        font-family: "Font Awesome 5 Pro";
        font-weight: 900;
    }

    .detail-item .sec-remove {
        position: absolute;
        top: 15px;
        right: 100px;
        background-color: transparent;
        margin: 0;
    }

    .edit-plan-detail .plan-head {
        padding-left: 5px;
        overflow: hidden;
        background-color: white;
        border-bottom: 1px solid #e6e6e6;
    }

    .edit-plan-detail .plan-head div p {
        margin-top: -4px;
    }

    .edit-plan-detail .plan-head div {
        display: inline-block;
        margin: 1px 0px 4px 28px;
    }

    .edit-plan-detail .plan-head > div {
        float: left;
    }

    .edit-plan-detail .plan-head > i {
        position: absolute;
        font-size: 24px;
        top: 48px;
    }

    .font-16 {
        font-size: 16px;
    }

    .text-l-gray {
        color: #999;
    }

    .edit-plan-detail .plan-body {
        padding: 5px;
        background-color: #fff;
    }

    .edit-plan-detail .plan-body table {
        width: 100%;
    }

    .edit-plan-detail .plan-body table tr td.wth30 {
        width: 30px;
    }

    .edit-plan-detail .plan-body table tr td.wth10 {
        width: 10px;
    }

    .edit-plan-detail .plan-body .v-top {
        vertical-align: top;
    }

    .text-m-gray {
        color: #666;
    }

    .edit-plan-detail .plan-body table tr td .first {
        width: 40px;
    }

    .bold {
        font-weight: bold !important;
    }

    .edit-plan-detail .plan-body table tr td .mheight38 {
        min-height: 38px;
    }

    .edit-plan-detail .plan-body table tr td .plan-title {
        margin-bottom: 3px;
    }

    .text-h-gray {
        color: #333;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content {
        color: #666;
        min-height: 10px;
        margin: 0;
    }

    .color333 {
        color: #333 !important;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item {
        position: relative;
        list-style: none;
        padding: 5px;
        border-bottom: 1px solid #ededed;
    }

    .clearfix:before, .clearfix:after {
        display: table;
        content: "";
        line-height: 0;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item > div {
        float: left;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item .detail-item-content-wrap {
        width: 100%;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item .detail-item-content-wrap .detail-item-content {
        margin-left: 30px;
    }

    .break-all {
        word-break: break-all;
    }

    .clearfix:after {
        clear: both;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .first {
        vertical-align: middle;
    }

    .edit-plan-detail .plan-body table tr td .conclusion {
        margin-bottom: 32px;
        border-bottom: 1px solid #dedede;
        border-top: 1px solid #dedede;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .second {
        padding: 32px 30px 26px 0;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .first.padding-top20 {
        padding-top: 20px;
    }

    .publish_button {
        padding: 3px 10px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .circleProgress {
        width: 2em;
        height: 2em;
        position: relative;
    }

    .circleProgress .progressNum {
        position: absolute;
        width: 1.5em;
        height: 1.5em;
        background-color: white;
        border-radius: 50%;
        left: 0.25em;
        top: 0.25em;
        line-height: 1.5em;
        text-align: center;
    }

    .circleLeft,
    .circleRight {
        width: 1em;
        height: 2em;
        overflow: hidden;
        position: relative;
        float: left;
        background-color: #1989FA;

    }

    .circleLeft {
        border-radius: 2em 0 0 2em;
    }

    .circleRight {
        border-radius: 0 2em 2em 0;
    }

    .circleLeft:after,
    .circleRight:after {
        content: "";
        position: absolute;
        display: block;
        width: 1em;
        height: 2em;
        background-color: white;
        border-radius: 2em 0 0 2em;
        background-color: #f2f2f2;
    }

    .circleRight:after {
        content: "";
        position: absolute;
        display: block;
        border-radius: 0 2em 2em 0;
    }

    .circle25 .circleLeft:after {
        transform-origin: right center;
    }

    .circle25 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(90deg);
    }

    .circle50 .circleLeft:after {
        transform-origin: right center;
    }

    .circle50 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .circle75 .circleLeft:after {
        transform-origin: right center;
        transform: rotateZ(90deg);
    }

    .circle75 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .circle100 .circleLeft:after {
        transform-origin: right center;
        transform: rotateZ(180deg);
    }

    .circle100 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .num {
        position: absolute;
        font-size: 12px;
        color: #878787;
        text-align: center;
        font-weight: bold;
    }

</style>
